import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { QQQuestionViewModel } from 'src/app/models/qq-question.view-model';

@Component({
  selector: 'app-display',
  templateUrl: './display.component.html',
  styleUrls: ['./display.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class DisplayComponent implements OnInit {
  @Input() question: QQQuestionViewModel;

  value: string;

  ngOnInit() {
    this.value = this.question.editingValue;
    if (this.question.options.Prefix)
      this.value = `${this.question.options.Prefix} ${this.question.editingValue}`;
  }
}
